module.exports = __webpack_public_path__ + "static/media/logo_club_limited_white.6939586b.svg";